import React from "react"
import { Column, Container, Row } from "../../components/Grid"
import Hero from "../../components/Hero"
import Icon from "../../components/Icon"
import Layout from "../../components/Layout"
import Resource from "../../components/Resource"
import Section from "../../components/Section"
import SEO from "../../components/Seo"
import SubFooterImage from "../../images/theme/img-subfooter-caregivers.jpg"
import "./caregiversStyles.scss"

const Caregivers = () => {
  return (
    <Layout className="caregivers">
      <SEO title="Caregivers" />
      {/***************  HERO ***************/}
      <Section className="hero">
        <Hero
          title="Caregivers"
          infographic="img-hero-infographic-caregivers.png"
          body="Use positive interactions at home to help educate children and teens on topics such as medication safety, mental health and substance misuse."
          image="img-hero-caregivers.jpg"
        />
      </Section>

      {/***************  CAREGIVER RESOURCES (CRs) ***************/}
      <Section className="midgray-background">
        <Container>
          <Row>
            <Column span={12}>
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="CAREGIVER GUIDE"
                image="CVS-Caregiver-MedicationSafety-Thumbnail.png"
                title="Medication Safety"
                description={
                  <p className="mt-2 mb-2">
                    This guide supports parents and caregivers in having
                    age-appropriate conversations about medication safety and
                    the importance of appropriate use of medicine with students
                    of all ages, offering resources and activities tailored to
                    grades K–12. By connecting school, home, and community, it
                    can help families in guiding students toward healthy
                    decision-making and overall well-being.
                  </p>
                }
                actions={[
                  {
                    label: "Caregiver Guide",
                    path:
                      "/docs/CVS-Pharma-DoK-CaregiverGuide-MedicationSafety.pdf",
                    type: "download",
                    locked: false,
                  },
                ]}
                horizontal
              />
              {/***************  CR: Stress Management and Mental Health ***************/}
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="CAREGIVER GUIDE"
                image="CVS-Pharma-CareerProfile-CaregiverGuide.jpg"
                title="Stress Management and Mental Health"
                description={
                  <p className="mt-2 mb-2">
                    This Caregiver Guide was created for parents, guardians, and
                    caretakers of students in grades K-12 to help facilitate
                    supportive conversations around the topics of stress
                    management and mental health. This guide uses
                    age-appropriate terminology, activities, tips, and
                    strategies to support conversations around maintaining
                    health and well-being.
                  </p>
                }
                actions={[
                  {
                    label: "Caregiver Guide",
                    path:
                      "https://d1moiqeuui7jlp.cloudfront.net/cc54a47e-136d-4ee4-a109-19fc6b7dfd31/1/cvs-pharma-dok-caregiverguide-v4.0.pdf?t=1742404236000",
                    type: "download",
                    locked: false,
                  },
                  // {
                  //   label: "Educator Guide",
                  //   path: "/docs/CVS-Pharma-DLB-Responding_to_Peer_Pressure-Pharmacists.pdf",
                  //   type: "download",
                  //   size: "PDF 1,000,000 GB",
                  //   locked: false
                  // }
                ]}
                horizontal
              />

              {/***************  CR: Critical Conversations with Children and Teens ***************/}
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="CAREGIVER GUIDE"
                image="thumbnail-caregiver-guide.jpg"
                title="Sparking critical conversations with children and teens"
                description={
                  <p className="mt-2 mb-2">
                    Find productive ways to initiate and maintain ongoing
                    discussions with children and teens regarding substance
                    misuse. Explore key background information, activity ideas,
                    and conversation starters based on student grade level with
                    this comprehensive guide for caregivers.
                  </p>
                }
                actions={[
                  {
                    label: "Caregiver Guide",
                    path:
                      "/docs/CVS-Pharma_DoK_CG_Critical-Conversations-with-Children-and-Teens.pdf",
                    type: "download",
                    locked: false,
                  },
                  // {
                  //   label: "Educator Guide",
                  //   path: "/docs/CVS-Pharma-DLB-Responding_to_Peer_Pressure-Pharmacists.pdf",
                  //   type: "download",
                  //   size: "PDF 1,000,000 GB",
                  //   locked: false
                  // }
                ]}
                horizontal
              />

              {/***************  ADDITIONAL CRs ***************/}
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="additional caregiver resources"
                image="caregivers-photo-addl-resources.jpg"
                description={
                  <p>
                    There are a variety of resources available to support
                    caregivers in critical conversations with the young people
                    in their lives.
                  </p>
                }
                horizontal
              >
                <Row>
                  <Column span={6} className="lh-i">
                    <div className="mb-1">
                      <b>Community Resources</b>
                    </div>
                    <ul>
                      <li style={{ marginBottom: "0.5rem" }}>
                        Local Pharmacists
                      </li>
                      <li style={{ marginBottom: "0.5rem" }}>Educator</li>
                      <li style={{ marginBottom: "0.5rem" }}>
                        School Counselor
                      </li>
                      <li style={{ marginBottom: "0.5rem" }}>
                        Pediatrician/ Family Doctor
                      </li>
                      <li style={{ marginBottom: "0.5rem" }}>
                        Mental Health Provider
                      </li>
                      <li style={{ marginBottom: "0.5rem" }}>
                        Other Healthcare Professional
                      </li>
                    </ul>
                  </Column>
                  <Column span={6}>
                    <div className="mb-1">
                      <b>Online Resources</b>
                    </div>
                    <div style={{ display: "flex" }}>
                      <Icon
                        className="fill-red mw-24"
                        name="rightarrow"
                        marginRight
                      />{" "}
                      <a
                        style={{ color: "#CC0000", marginBottom: "0.5rem" }}
                        href="https://www.samhsa.gov/"
                        target="_blank"
                      >
                        SAHMSA
                      </a>
                    </div>
                    <div style={{ display: "flex" }}>
                      <Icon
                        className="fill-red mw-24"
                        name="rightarrow"
                        marginRight
                      />{" "}
                      <a
                        style={{ color: "#CC0000", marginBottom: "0.5rem" }}
                        href="http://www.drugfree.org/"
                        target="_blank"
                      >
                        Partnership for Drug-Free Kids
                      </a>
                    </div>
                    <div style={{ display: "flex" }}>
                      <Icon
                        className="fill-red mw-24"
                        name="rightarrow"
                        marginRight
                      />{" "}
                      <a
                        style={{ color: "#CC0000", marginBottom: "0.5rem" }}
                        href="http://teens.drugabuse.gov/"
                        target="_blank"
                      >
                        NIDA for Teens
                      </a>
                    </div>
                    <div style={{ display: "flex" }}>
                      <Icon
                        className="fill-red mw-24"
                        name="rightarrow"
                        marginRight
                      />{" "}
                      <a
                        style={{ color: "#CC0000", marginBottom: "0.5rem" }}
                        href="https://www.betterwithout.it/"
                        target="_blank"
                      >
                        Better without It
                      </a>
                    </div>
                    <div style={{ display: "flex" }}>
                      <Icon
                        className="fill-red mw-24"
                        name="rightarrow"
                        marginRight
                      />{" "}
                      <a
                        style={{ color: "#CC0000" }}
                        href="https://ncsacw.acf.hhs.gov/"
                        target="_blank"
                      >
                        National Center on Substance Abuse and Child Welfare
                      </a>
                    </div>
                  </Column>
                </Row>
              </Resource>
            </Column>
          </Row>
        </Container>
      </Section>

      {/***************  ABOVE FOOTER CALLOUT ***************/}
      <Section className="subfooter">
        <Container>
          <Row>
            <Column span={4}>
              <img
                src={SubFooterImage}
                className="subfooter-image"
                alt="Title: Facts, Info etc."
              />
            </Column>
            <Column span={8}>
              <h3>Fact:</h3>
              <p>
                Only 57.2 percent of adolescents talk to their parents about the
                dangers of substance use.
              </p>
              <p>
                <a
                  href="https://www.samhsa.gov/data/sites/default/files/report_3380/ShortReport-3380.html#:~:text=As%20previously%20noted%2C%20the%20majority,program%20outside%20of%20school%20(Figure"
                  target="_blank"
                >
                  <em>
                    —Substance Abuse and Mental Health Services Administration
                    (SAMHSA)
                  </em>
                </a>
              </p>
            </Column>
          </Row>
        </Container>
      </Section>
    </Layout>
  )
}

export default Caregivers
